import React, { useState, useEffect } from 'react';
import LeftPanel from './components/LeftPanel';
import CursorGlow from './components/CursorGlow';
import About from './sections/About';
import Experience from './sections/Experience';
import Projects from './sections/Projects';

export default function App() {
  const [activeSection, setActiveSection] = useState('about');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -60% 0px' }
    );

    ['about', 'experience', 'projects'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={{ backgroundColor: '#0f172a', minHeight: '100vh' }}>
      <CursorGlow />
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          display: 'flex',
          padding: '0 96px',
        }}
      >
        {/* Sticky left panel */}
        <div
          style={{
            position: 'sticky',
            top: 0,
            height: '100vh',
            width: '33%',
            flexShrink: 0,
          }}
        >
          <LeftPanel activeSection={activeSection} onNavClick={scrollTo} />
        </div>

        {/* Scrollable right panel */}
        <main style={{ flex: 1, padding: '96px 0 96px 16px' }}>
          <About />
          <Experience />
          <Projects />
          <footer style={{ paddingBottom: '48px' }}>
            <p style={{ fontSize: '13px', color: '#334155' }}>
              Designed &amp; Built by Esosa Emwionkpa
            </p>
          </footer>
        </main>
      </div>
    </div>
  );
}
